import { parseCellId } from '@cards/engine';
import { cardRef, defineGameCard, ongoing } from '../authoring/index.js';
const BARRIER_ID = 'barrier';
function durationDescription(effect) {
    if (effect.duration !== undefined)
        return `Осталось раундов: ${effect.duration}.`;
    return effect.persistent ? 'Постоянный эффект.' : 'Действует, пока активен источник.';
}
/** Playable M10 structure with a derived source-bound location aura. */
export const BarrierCard = defineGameCard({
    id: BARRIER_ID,
    gameplay: {
        type: 'STRUCTURE',
        cost: 2,
        baseStats: { attack: 0, health: 4 },
    },
    presentation: {
        name: 'Барьер',
        description: 'Постоянно: ваши карты в этой локации получают на 2 меньше урона.',
        glyph: {
            colors: ['transparent', '#10213a', '#abf5fc', '#2ec7d4', '#18a6d4'],
            rows: [
                '........2222........',
                '.......234442.......',
                '......23444442......',
                '....223444444422....',
                '...24444444454442...',
                '...24424444552442...',
                '..2344425555244442..',
                '.234444522224444432.',
                '.244445344453444452.',
                '.244442444442344452.',
                '.244452444444244552.',
                '.244452444444245552.',
                '.244453544443535532.',
                '..2452452443542532..',
                '...22443522244522...',
                '....244444444552....',
                '....244444445532....',
                '.....2444445532.....',
                '......22222222......',
                '....................',
            ],
        },
    },
    role: 'standalone_lab',
    dependencies: [cardRef(BARRIER_ID)],
    abilities: [
        ongoing((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return [];
            const tableId = parseCellId(self.cellId).tableId;
            return ctx.q.unitsOf(self.controllerId)
                .filter((card) => card.cellId !== undefined
                && parseCellId(card.cellId).tableId === tableId)
                .map((card) => ({
                abilityId: `location_protection:${card.id}`,
                scope: { kind: 'unit', instanceId: card.id },
                statMods: [],
            }));
        }),
    ],
    hooks: {
        modifyIncomingDamage(ctx, planned) {
            if (planned.target.kind !== 'unit')
                return planned.amount;
            return Math.max(0, planned.amount - 2);
        },
    },
    ui: {
        effectStatusProviders: [(_context, effects) => {
                const effect = effects[0];
                if (effect === undefined)
                    return [];
                const count = effects.length;
                return [{
                        id: 'barrier',
                        symbol: '▣',
                        label: count === 1 ? 'Барьер' : `Барьер ×${count}`,
                        description: `Получает на ${count * 2} меньше урона в этой локации. ${durationDescription(effect)} Источник: Барьер.`,
                        tone: 'positive',
                    }];
            }],
    },
});
//# sourceMappingURL=barrier.js.map